"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getApiErrors;

var _get = _interopRequireDefault(require("lodash/get"));

var _isApiError = _interopRequireWildcard(require("./is-api-error"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Parses an action for a payload containing the result of a call to the Flow API. If the payload
 * contains an error model, as defined by the API spec, then those errors will be flattened into a
 * resulting array of [error].
 *
 * Supports the following error types:
 * - standard generic_errors - https://docs.flow.io/type/generic-error
 * - order builder errors - https://docs.flow.io/type/order-builder
 *
 * @param {Object} action - redux action
 */
function getApiErrors() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if ((0, _isApiError.default)(action)) {
    var payload = action.payload;

    if ((0, _isApiError.isStandardError)(payload)) {
      return [payload];
    }

    if ((0, _isApiError.isOrderBuilderError)(payload)) {
      return (0, _get.default)(payload, 'errors', []);
    }

    return [];
  }

  return [];
}